module.exports = __webpack_public_path__ + "img/nav_application_zgcg.f9b5a2b9.png";